var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Email",
    transform: "translate(-27.555 -10.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(27.555 10.336)",
    fill: "#fff",
    stroke: "#ddd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "OTP",
    transform: "translate(46.555 47.336)",
    fill: "#474b4f",
    fontSize: 14,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500,
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OTP")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOtp);
export default __webpack_public_path__ + "static/media/icon_otp.be1740eda6d62eb56bba2669b2efde91.svg";
export { ForwardRef as ReactComponent };